import React from "react";
import { EmptyLayoutComponent } from "../_shared/emptyLayout/EmptyLayoutComponent";
import { IState } from "../../../../common/state/IState";
import { useSelector } from "react-redux";

const selector = (s: IState) =>
    s?.userManagement?.subscriptionPreferences?.error;

export const UmSpErrorScreenComponent = () => (
    <EmptyLayoutComponent message={useSelector(selector)} />
);
